import React from 'react';
import FAQ from '../components/home/FAQ';
import FinalCTA from '../components/home/FinalCTA';

const FAQPage: React.FC = () => {
  return (
    <main className="pt-20">
      <div className="bg-brand-navy py-24 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-black mb-6">Help Center</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            Find answers to common questions about our cleaning services and policies.
          </p>
        </div>
      </div>
      <FAQ />
      <div className="py-24 bg-brand-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl font-black text-brand-navy mb-4">Still have questions?</h2>
          <p className="text-brand-navy/70 mb-8">Our friendly team is here to help you.</p>
          <a 
            href="tel:2018700452" 
            className="inline-flex items-center space-x-3 bg-brand-blue text-white px-8 py-4 rounded-2xl font-bold shadow-xl hover:bg-blue-700 transition-all"
          >
            <span>Call (201) 870-0452</span>
          </a>
        </div>
      </div>
      <FinalCTA />
    </main>
  );
};

export default FAQPage;
